import { render, staticRenderFns } from "./DataImportFilesGrid.vue?vue&type=template&id=3a3213e3"
import script from "./DataImportFilesGrid.vue?vue&type=script&lang=js"
export * from "./DataImportFilesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports